// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oHcUA","name":"styles_name__3vvn1","phone":"styles_phone__2e_bu"};